import constants from '../../config/constants'

import moment from '../dates/moment'

export default (startDate, endDate, years) => {
  const momentStartDate = moment(startDate, constants.frontEndDateFormat, true)
  const momentEndDate = moment(endDate, constants.frontEndDateFormat, true)

  const difference = momentEndDate.diff(momentStartDate, 'years', true)

  return difference >= years
}
